import { Furigana } from "~/components/common/Furigana";
import { H4 } from "~/components/common/Typography";
import { Separator } from "~/components/ui/separator";
import { cn } from "~/lib/utils";
import { type SelectLemma } from "~/server/db/lemmas/schema";

export default function CardContentLemma({
  lemma,
  className,
}: {
  lemma: SelectLemma;
  className?: string;
}) {
  if (!lemma) return null;

  return (
    <div className={cn("space-y-4", className)}>
      <Separator />
      <H4 className="text-sm">Base Form</H4>
      <div className="">
        <Furigana rubyContent={lemma.textFurigana ?? lemma.text} />
      </div>
    </div>
  );
}
